<template>
  <s-modal :show="visible">
    <div class="confirm-delete-popup" v-if="visible">
      <div class="confirm-delete-popup_content">
        <p
          class="confirm-delete-popup_title"
          :class="{ 'title-custom': config.changeStyle, 'title-custom_1': !config.changeStyle }"
          v-html="config.title"
        ></p>
        <p
          class="confirm-delete-popup_desc"
          :class="{ 'desc-custom': config.changeStyle, 'desc-custom_1': !config.changeStyle }"
          v-html="config.message"
        ></p>

        <div class="confirm-delete-popup_button-group">
          <a
            href="javascript:;"
            class="s-button cancel-btn mt-3"
            @click="handleCancelModal()"
            >{{ config.textCancelButton }}</a
          >
          <button
            type="button"
            class="s-button submit-btn"
            href="javascript:;"
            :title="config.textSubmitButton"
            @click="handleSubmitModal()"
          >
            {{ config.textSubmitButton }}
          </button>
        </div>
      </div>
    </div>
  </s-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      config: {
        title: null,
        message: null,
        textSubmitButton: null,
        textCancelButton: null,
        customClass: 'confirm-modal',
        linkTo: '',
        changeStyle: false,
      },
    }
  },

  methods: {
    show(config = {}) {
      this.visible = true
      config.customClass =
        this.config.customClass.concat(' ', config.customClass) || ''

      this.config = { ...this.config, ...config }
    },

    hide() {
      this.visible = false
      this.$emit('hide')
    },

    handleSubmitModal() {
      this.$emit('submit')
    },
    handleCancelModal() {
      this.hide()
      this.$emit('cancal')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './modal-confirm.scss';
</style>
